/* 


@PRAKT


   _____________________________________________________________

   |
   | CUSTOM FORMS
   |
   _____________________________________________________________
*/

import gsap from 'gsap';

/* ______________________________________________________________

   |
   | CLASS
   |
   ______________________________________________________________
*/

export default class CustomForms {
    constructor() {
        this.init();
    }

    init() {
        this.form_login = document.querySelector( '.form_login_customer' );
        this.form_recover = document.querySelector( '.form_login_recover')
        this.form_register = document.querySelector( '.form_register_customer' );
        this.form_address = document.querySelector( '.form_update_customer.address' );
        this.form_sign = document.querySelector( '.form_update_customer.sign' );
        this.form_simple_registration = document.querySelector( '.form_simple_registration' );
        this.form_access_code = document.querySelector( '.form_acces_code' );

        if( !this.form_login 
            && !this.form_register 
            && !this.form_address 
            && !this.form_sign 
            && !this.form_simple_registration 
            && !this.form_access_code
        ) return;

        this.confirm_box = document.querySelectorAll( '.raffle_confirm_wrapper' );
        this.waiter = document.querySelectorAll( '.raffle_confirm_wrapper .waiter' );
        this.confirm_message = document.querySelector( '.raffle_confirm_wrapper .confirm_message' );

        const get_prefix = document.querySelector( '.login__form' ).dataset.prefix;
        this.tag_prefix = get_prefix ? get_prefix+'_' : 'raffle_';
        this.tag_list = [];

        if( this.form_address || this.form_sign ) {
            this.form_current = document.querySelector( '.form_update_customer' );
            // this.server_file_url = 'https://prakt.dev/hcc/hcc-update-customer.php';
            this.customer_id = this.form_current.dataset.customerId;
            this.raffle_title = this.form_current.dataset.raffleTitle;
            this.tag_list.push( this.raffle_title );
        }

        if( this.form_simple_registration ) {
            this.form_current = document.querySelector( '.form_simple_registration' );
            // this.server_file_url_simple_registration = 'https://prakt.dev/hcc/hcc-raffle-registration.php';
            this.raffle_title = this.form_current.dataset.raffleTitle;
            this.tag_list.push( this.raffle_title );
        }

        if( this.form_access_code ) {
            this.form_current = document.querySelector( '.form_acces_code' );
            this.controlCodeAccessDisplay();
        }

        if( this.form_login ) this.customerLogin();
        if( this.form_recover ) this.customerRecover();
        if( this.form_register ) this.customerRegister();
        if( this.form_address ) this.updateAddress();
        if( this.form_sign ) this.updateTag();
        if( this.form_simple_registration ) this.simpleRegistration();
        if( this.form_simple_registration ) this.simpleRegistrationMessageDisplayControl();
        if( this.form_access_code ) this.accessCode();

        this.formSwitch();
        this.loginRecoverForms();
        this.isNewCustomer();
        this.recoverSucess();
        this.checkAndActiveFormOnLoad();
        this.cleanErrorsOnLoad();
        this.showHidePassword();
    }

    fieldErrors() {
        const fields = this.form_current.querySelectorAll( 'input[required]' );
        // const excluded_fields = [ 'email', 'password', 'password_confirmation' ];
        const excluded_fields = [];
        let missing_fields = [];
        fields.forEach( f => {
            const is_excluded = excluded_fields.some( control => f.name.includes( control ) );
            const is_empty = f.type === 'checkbox' ? !f.checked : !f.value.trim();
            if ( !is_excluded && is_empty ) {
                const error_message = f.getAttribute( 'data-error' ) || 'Required';
                f.classList.add( 'hcc_field_error' );
                missing_fields.push( error_message );
            } else if( !is_empty || f.classList.contains( 'field_error' ) ) f.classList.remove( 'hcc_field_error' );
        });
        return missing_fields;
    }

    fieldControls() {
        let has_error = false;
        const missing_fields = this.fieldErrors();
        if ( missing_fields.length > 0 ) {
            has_error = true;
            let error_list = '';
            missing_fields.forEach( error => {
                error_list += `<li>${ error }</li>`;
            } );
            this.showErrors( error_list );
        }
        return has_error;
    }

    shopifyFieldControls( responseText ) {
        let has_error = false;
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseText, 'text/html' );
        const shopify_errors = doc.querySelectorAll( '.hcc_form_error_native' );
        if( shopify_errors.length > 0 ) {
            const first_error_in_doc = shopify_errors[ 0 ];
            const shopify_error_elements = first_error_in_doc.querySelectorAll( 'li' );
            if ( shopify_error_elements.length > 0 ) {
                has_error = true;
                let error_list = '';
                shopify_error_elements.forEach( error => {
                    const error_message = error.textContent;
                    error_list += `<li>${ error_message }</li>`;
                } );            
                this.showErrors( error_list );
            }
        }
        return has_error;
    }

    showErrors( message ) {
        const form_error = this.form_current.querySelector( '.hcc_form_error' );
        const form_error_content = this.form_current.querySelector( '.hcc_form_error ul' );
        form_error_content.innerHTML = message;
        form_error.style.display = 'block';
        gsap.fromTo( form_error, {
            opacity: 0,
            height: 0
        }, {
            duration: 0.5,
            ease: 'power3.inOut',
            opacity: 1,
            height: 'auto',
            marginTop: '2rem',
        } );
    }

    hideErrors() {
        const form_error = document.querySelector( '.hcc_form_error' );
        const form_error_content = document.querySelector( '.hcc_form_error ul' );
        if( form_error.style.display == 'none' || form_error_content.innerHTML == '' ) return;
        gsap.to( form_error, {
            duration: 0.5,
            ease: 'power3.inOut',
            opacity: 0,
            height: 0,
            marginTop: 0,
            onComplete: () => {
                form_error.style.display = 'none';
            }
        } );
    }

    /* ______________________________________________________________

    |
    | FORM DATA
    |
    ______________________________________________________________
    */

    customerLogin() {
        const button = this.form_login.querySelector( '.login__sign-in' );
        button.addEventListener( 'click', async ( event ) => {
            event.preventDefault();
            this.form_current = this.form_login;
            const has_error = this.fieldControls();
            if( has_error ) return;
            this.openWaiter();
            this.hideForm();
            this.form_login.submit();       
        } );
    }

    customerRecover() {
        const button = this.form_recover.querySelector( '.button--primary' );
        button.addEventListener( 'click', ( event ) => {
            event.preventDefault();
            this.form_current = document.querySelector( '.hcc_login_recover' );
            const has_error = this.fieldControls();
            if ( has_error ) return;
            this.openWaiter();
            this.hideForm();
            window.Shopify.captcha.protect( this.form_recover, () => {
                this.form_recover.submit();
            });
        });
    }

    customerRegister() {
        const button = this.form_register.querySelector( '.button__create-account' );
        button.addEventListener( 'click', ( event ) => {
            event.preventDefault();
            this.form_current = this.form_register;
            const has_error = this.fieldControls();
            if( has_error ) return;
            this.openWaiter();
            this.hideForm();
            this.form_register.submit();  
        } )
    }

    updateAddress() {
        const button = this.form_address.querySelector( '.button__create-account' );
        button.addEventListener( 'click', ( event ) => {
            event.preventDefault();
            this.form_current = this.form_address;
            if ( this.fieldControls() ) return;
            this.windowScrollToForm();
            this.openWaiter();
            this.hideForm();
            let tags = '';
            this.tag_list.forEach( t => {
                tags = tags + `${ this.tag_prefix }${ t }, `;
            } );
            tags = tags.substring( 0, tags.length - 2 );
            window.Shopify.captcha.protect( this.form_address, async () => {
                // console.log( '⚙️ update tags' );
                try {
                    await fetch( 'https://prakt.dev/hcc/hcc-update-customer.php', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams({
                            customer_id: `${ this.customer_id }`,
                            // tags: `${ this.tag_prefix }${ this.raffle_title }`
                            tags: `${ tags }`
                        })
                    });
                    // console.log( '🎉 tags updated' );
                    // console.log( '👉 submit form' );
                    this.form_address.submit();
                } catch ( error ) {
                    console.error( 'ERR: ', error );
                    this.closeWaiter();
                    this.showForm();
                    this.showErrors( `⚠️ ERR [ ${error} ]. Please try again or reload the page. If the issue persists, please contact us.` );
                }
            } );
        } );
    } 

    updateTag() {
        const button = this.form_sign.querySelector( '.button__create-account' );
        button.addEventListener( 'click', ( event ) => {
            event.preventDefault();
            this.form_current = this.form_sign;
            if ( this.fieldControls() ) return;
            this.windowScrollToForm();
            this.openWaiter();
            this.hideForm();
            let tags = '';
            this.tag_list.forEach( t => {
                tags = tags + `${ this.tag_prefix }${ t }, `;
            } );
            tags = tags.substring( 0, tags.length - 2 );
            window.Shopify.captcha.protect( this.form_sign, async () => {
                try {
                    await fetch( 'https://prakt.dev/hcc/hcc-update-customer.php', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams({
                            customer_id: `${ this.customer_id }`,
                            // tags: `${ this.tag_prefix }${ this.raffle_title }`
                            tags: `${ tags }`
                        })
                    });
                    this.closeWaiter();
                    setTimeout( () => location.reload(), 500 );
                } catch ( error ) {
                    console.log( 'ERR: ', error );
                    this.closeWaiter();
                    this.showForm();
                    this.showErrors( `⚠️ ERR [ ${error} ]. Please try again or reload the page. If the issue persists, please contact us.` );
                }
            } );
        });
    }

    simpleRegistration() {
        const button = this.form_simple_registration.querySelector( '.button__create-account' );
        button.addEventListener( 'click', ( event ) => {            
            event.preventDefault();
            this.form_current = this.form_simple_registration;
            if ( this.fieldControls() ) return;
            this.windowScrollToForm();
            this.openWaiter();
            this.hideForm(); 
            window.Shopify.captcha.protect( this.form_simple_registration, async () => {
                try {
                    const response = await fetch( 'https://prakt.dev/hcc/hcc-raffle-registration.php', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            email: this.form_simple_registration.querySelector('[name="customer[email]"]').value,
                            first_name: this.form_simple_registration.querySelector('[name="customer[first_name]"]').value,
                            last_name: this.form_simple_registration.querySelector('[name="customer[last_name]"]').value,
                            tags: `${ this.tag_prefix }${this.raffle_title}`
                        })
                    });
                    const result = await response.json();
                    // console.log('Réponse PHP:', result);
                    if (result.status === 'created') {
                        this.form_simple_registration.submit(); 
                    } else {
                        const url = new URL(window.location.href);
                        url.searchParams.set('registered', '1');
                        window.location.href = url.toString();
                    }
                } catch ( error ) {
                    console.error( 'ERR: ', error );
                    this.closeWaiter();
                    this.showForm();
                    this.showErrors( `⚠️ ERR [ ${error} ]. Please try again or reload the page. If the issue persists, please contact us.` );
                }
            });
        });
    } 

    simpleRegistrationMessageDisplayControl() {
        const info_message = document.querySelector( '.raffle_step_info.simple_registration' );
        const confirm_message = document.querySelector( '.raffle_after_message.simple_registration' );
        const control_url_parameters = new URLSearchParams(window.location.search);
        if ( control_url_parameters.get( 'registered' ) === '1' || control_url_parameters.get( 'return' ) === 'registercustomer' ) {
            info_message.style.display = 'none';
            confirm_message.style.display = 'block';
            this.form_simple_registration.style.display = 'none';
            this.form_simple_registration.style.visibility = 'hidden';
        } else {
            info_message.style.display = 'block';
            confirm_message.style.display = 'none';
            this.form_simple_registration.style.display = 'flex';
            this.form_simple_registration.style.visibility = 'visible';
        }
    }

    accessCode() {
        const button = this.form_access_code.querySelector( '.button--primary' );
        button.addEventListener( 'click', ( event ) => {
            event.preventDefault();
            this.form_current = document.querySelector( '.form_acces_code' );
            const has_error = this.fieldControls();
            if ( has_error ) return;
            this.openWaiter();
            this.hideForm();
            const get_code = this.form_access_code.querySelector( '[name="code"]' ).value;
            const code = get_code.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9-_]/g, '').toUpperCase();
            const formData = new URLSearchParams();
            const error_message = document.documentElement.lang == 'en' ? 'Invalid code' : 'Code invalide';
            formData.append( 'code', code );
            formData.append( 'current_url', window.location.href );
            window.Shopify.captcha.protect( this.form_access_code, async () => {
                try {
                    const response = await fetch( 'https://prakt.dev/hcc/hcc-validate-access-code-2.php', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: formData.toString()
                    } );
                    const data = await response.json();
                    if ( data.success ) {
                        this.accessCodeSetLocalAccess( data.submitted_code );
                        setTimeout( () => {
                            window.location.href = data.redirect_url;
                        }, 500 );
                    } else {
                        console.log( 'ERR reponse' );
                        this.showErrors( `⚠️ ${ error_message }` );
                        this.showForm();
                        this.closeWaiter();
                    }
                } catch ( error ) {
                    console.log( 'ERR: ', error );
                    this.closeWaiter();
                    this.showForm();
                    this.showErrors( `⚠️ ERR [ ${error} ]. Please try again or reload the page. If the issue persists, please contact us.` );
                }
            } );
        } );
    }

    accessCodeSetLocalAccess( submitted_code ) {
        this.setCookie( 'visitor_granted', true, 40 );
        this.setCookie( 'visitor_granted_with', submitted_code, 40 );
    }

    controlCodeAccessDisplay() {
        const block_list = document.querySelectorAll( '.access_block' );
        block_list[ 0 ].classList.remove( 'has_access' );
        const access_granted = Boolean( this.getCookie( 'visitor_granted' ) );
        const access_granted_with = this.getCookie( 'visitor_granted_with' );
        const alredy_granted = block_list[ 1 ].classList.contains( 'granted' );
        if( access_granted || alredy_granted ) {
            if( access_granted_with ) this.tag_list.push( `granted_with_${ access_granted_with }` )
            block_list[ 0 ].classList.add( 'has_access' );
            block_list[ 1 ].classList.remove( 'need_access' );
        }
    }

    setCookie( cname, cvalue, exdays ) {
        const d = new Date();
        d.setTime( d.getTime() + ( exdays*24*60*60*1000 ) );
        // d.setTime( d.getTime() + ( 20*1000 ) ); // Test 20s
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie( cname ) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent( document.cookie );
        let ca = decodedCookie.split( ';' );
        for( let i = 0; i <ca.length; i++ ) {
            let c = ca[ i ];
            while ( c.charAt( 0 ) == ' ' ) {
                c = c.substring( 1 );
            }
            if ( c.indexOf( name ) == 0 ) {
                return c.substring( name.length, c.length );
            }
        }
        return '';
    }

    /* ______________________________________________________________

    |
    | TRICKS FORM DATA
    |
    ______________________________________________________________
    */

    isNewCustomer() {
        const terms = document.querySelector( '.raffle_terms' );
        const url = new URL( window.location ).searchParams;
        const return_value = url.get( 'return' );
        // if( return_value == 'customernow' && terms ) {
        if( return_value == 'registercustomer' && terms ) {
            terms.remove();
        }
    }

    recoverSucess() {
        const message = document.querySelector( '.hcc_recover_success' );
        const url = new URL( window.location ).searchParams;
        const return_value = url.get( 'return' );
        if( return_value == 'recoversuccess' && message ) {
            message.style.display = 'block';
            const url = new URL( window.location );
            if ( url.searchParams.has( 'return' ) ) {
                url.searchParams.delete( 'return' );
                window.history.replaceState( {}, '', url );
            }
        }
    }

    /* ______________________________________________________________

    |
    | INTERACTION UI
    |
    ______________________________________________________________
    */

    openWaiter() {
        // this.waiter.style.display = 'block';
        gsap.set( this.waiter, { display: 'block' } );
        gsap.to( this.confirm_box, {
            duration: 0.2,
            ease: 'power3.out',
            height: '8rem'
        } );
        gsap.fromTo( this.waiter, {
            opacity: 0,
            scale: 2
        }, {
            duration: 0.5,
            ease: 'power3.inOut',
            opacity: 1,
            scale: 1
        } );
    }

    closeWaiter() {
        gsap.to( this.confirm_box, {
            duration: 0.2,
            ease: 'power3.out',
            height: 0
        } );

        gsap.to( this.waiter, {
            duration: 0.5,
            ease: 'power3.inOut',
            opacity: 0,
            scale: 2,
            onComplete: () => {
                // this.waiter.style.display = 'none';
                gsap.set( this.waiter, { display: 'none' } );
            }
        } );
    }

    showForm() {
        gsap.to( this.form_current, {
            duration: 0.5,
            ease: 'power3.inOut',
            opacity: 1,
            y: 0
        } )
    }

    hideForm() {
        gsap.to( this.form_current, {
            duration: 0.5,
            ease: 'power3.inOut',
            opacity: 0,
            y: '2rem'
        } )
    }

    windowScrollToForm() {
        const scroll_y = window.scrollY;
        const form_y = this.form_current.getBoundingClientRect().y;
        const target = scroll_y + form_y - 80;        
        window.scrollTo( 0, target );
    }

    formSwitch() {
        const menu = document.querySelector( '#form_switch_menu' );
        if( !menu ) return;
        const login_button = menu.querySelector( '.login' );
        const register_button = menu.querySelector( '.register' );
        const form_login = document.querySelector( '.form_login_customer' );
        const form_register = document.querySelector( '.form_register_customer' );
        const login_recover_block = document.querySelector( '.hcc_login_recover_block' );
        const login_form = document.querySelector( '.hcc_login_form' );
        const recover_form = document.querySelector( '.hcc_login_recover' );
        const buttons = menu.querySelectorAll( 'button' );
        let can_loop = true;
        buttons.forEach( b => {
            if( !can_loop ) return;
            if( b.classList.contains( 'login' ) ) {
                login_button.classList.add( 'active' );
                form_register.style.display = 'none';
            } 
            if( b.classList.contains( 'register' ) ) {
                register_button.classList.add( 'active' );
                login_recover_block.style.display = 'none';
            }
            can_loop = false;
        } );
        
        login_button.addEventListener( 'click', () => {
            window.location.hash = 'login';
            this.form_current = form_login;
            if( login_button.classList.contains( 'active' ) ) return;
            login_button.classList.add( 'active' );
            register_button.classList.remove( 'active' );
            form_login.style.display = 'block';
            hide( form_register );
            show( login_recover_block );
        } );
        register_button.addEventListener( 'click', () => {
            window.location.hash = 'register';
            this.form_current = form_register;
            if( register_button.classList.contains( 'active' ) ) return;
            register_button.classList.add( 'active' );
            login_button.classList.remove( 'active' );
            hide( login_recover_block );
            show( form_register );
            if( login_form.style.display == 'none' ) {
                show( login_form );
                hide( recover_form );
            }
        } );
        const show = ( target ) => {
            gsap.fromTo( target, {
                opacity: 0,
                y: '2rem'
            }, {
                delay: 0.5,
                duration: 0.5,
                ease: 'power3.inOut',
                opacity: 1,
                y: 0,
                onStart: () => {
                    target.style.display = 'block';
                }
            } );
        }
        const hide = ( target ) => {
            gsap.to( target, {
                duration: 0.5,
                ease: 'power3.inOut',
                opacity: 0,
                y: '-2rem',
                onComplete: () => {
                    target.style.display = 'none';
                }
            } );
        }
    }

    loginRecoverForms() {
        const login_form = document.querySelector( '.hcc_login_form' );
        const recover_form = document.querySelector( '.hcc_login_recover' );
        if( !login_form || !recover_form ) return;
        recover_form.style.display = 'none';
        const forgot_button = login_form.querySelector( '.login__forgot-password' );
        const cancel_button = recover_form.querySelector( '.login__create-acc' );
        forgot_button.addEventListener( 'click', () => {
            window.location.hash = 'recover';
            this.form_current = this.form_recover;
            hide( login_form );
            show( recover_form );
        } );
        cancel_button.addEventListener( 'click', () => {
            this.form_current = this.form_recover;
            hide( recover_form );
            show( login_form );
        } );
        const show = ( target ) => {
            gsap.fromTo( target, {
                opacity: 0,
                y: '2rem'
            }, {
                delay: 0.5,
                duration: 0.5,
                ease: 'power3.inOut',
                opacity: 1,
                y: 0,
                onStart: () => {
                    target.style.display = 'block';
                }
            } );
        }
        const hide = ( target ) => {
            gsap.to( target, {
                duration: 0.5,
                ease: 'power3.inOut',
                opacity: 0,
                y: '-2rem',
                onComplete: () => {
                    target.style.display = 'none';
                }
            } );
        }
    }

    checkAndActiveFormOnLoad() {
        const menu = document.querySelector( '#form_switch_menu' );
        if( !menu ) return;
        const login_button = menu.querySelector( '.login' );
        const register_button = menu.querySelector( '.register' );
        const form_login = document.querySelector( '.form_login_customer' );
        const form_register = document.querySelector( '.form_register_customer' );

        const login_recover_block = document.querySelector( '.hcc_login_recover_block' );
        const login_form = document.querySelector( '.hcc_login_form' );
        const recover_form = document.querySelector( '.hcc_login_recover' );

        const url = new URL( window.location ).searchParams;
        const return_value = url.get( 'return' );
        if( return_value == 'registercustomer' ) {
            login_button.classList.remove( 'active' );
            register_button.classList.add( 'active' );
            form_login.style.display = 'none';
            form_register.style.display = 'block';
        }

        // Login failed
        const login_errors = document.querySelectorAll( '.form_login_customer .hcc_form_error_native li' );
        const is_login_page = window.location.pathname.includes( '/account/login' );
        const other_on_login_page = window.location.search.includes( '?return' );
        if( login_errors.length > 0 && is_login_page && !other_on_login_page ) {
            login_button.classList.add( 'active' );
            register_button.classList.remove( 'active' );
            login_recover_block.style.display = 'block';
            form_login.style.display = 'block';
            recover_form.style.display = 'none';
            form_register.style.display = 'none';
        }
        
        // Check hash
        const hash = window.location.hash.substring( 1 );
        if( !hash ) return;
        if( hash == 'login' ) {
            login_button.classList.add( 'active' );
            register_button.classList.remove( 'active' );
            login_recover_block.style.display = 'block';
            form_login.style.display = 'block';
            recover_form.style.display = 'none';
            form_register.style.display = 'none';
        }
        if( hash == 'register' ) {
            login_button.classList.remove( 'active' );
            register_button.classList.add( 'active' );
            login_recover_block.style.display = 'none';
            form_register.style.display = 'block';
        }

        if( hash == 'recover' ) {
            this.form_current = this.form_recover;
            recover_form.style.display = 'block';
            login_form.style.display = 'none';
            login_button.classList.add( 'active' );
            register_button.classList.remove( 'active' );
            login_recover_block.style.display = 'block';
            form_login.style.display = 'block';
            form_register.style.display = 'none';
        }
    }

    cleanErrorsOnLoad() {        
        const form_login = document.querySelector( '.form_login_customer' );
        const form_register = document.querySelector( '.form_register_customer' );
        const login_errors = document.querySelectorAll( '.form_login_customer .hcc_form_error_native li' );
        const register_errors = document.querySelectorAll( '.form_register_customer .hcc_form_error_native li' );
        if( login_errors.length == 0 && register_errors.length == 0 ) return;
        const is_login_page = window.location.pathname.includes( '/account/login' );
        const other_on_login_page = window.location.search.includes( '?return' );
        const register_failed = window.location.search.includes( 'return=registercustomer' );
        if( is_login_page && !other_on_login_page ) {
            form_register.querySelector( '.hcc_form_error_native' ).remove();
        }
        if( register_failed ) {
            form_login.querySelector( '.hcc_form_error_native' ).remove();
        }
    }

    defineSessionStorage( current_url ) {
        sessionStorage.setItem( 'hcc_login_origin', current_url);
    }

    removeSessionStorage() {
        sessionStorage.removeItem( 'hcc_login_origin' );
    }

    showHidePassword() {
        const passwords = document.querySelectorAll( '.field_password' );
        if( passwords.length < 1 ) return;
        passwords.forEach( p => {
            const show = p.querySelector( '.field__password-type-show' );
            const hide = p.querySelector( '.field__password-type-hide' );
            const input = p.querySelector( 'input' );
            show.addEventListener( 'click', () => {
                hide.style.display = 'block';
                show.style.display = 'none';
                input.type = 'text';
            } );
            hide.addEventListener( 'click', () => {
                hide.style.display = 'none';
                show.style.display = 'block';
                input.type = 'password';
            } );
        } );
    }
}